import { InvoiceResponse } from "../../../../Shared/React/typings/api-models/invoice"
import { ActionType, createAsyncAction, createStandardAction } from "typesafe-actions";

const actions = {
    getInvoices: createAsyncAction(
        '[InvoiceResponse] GetInvoices // REQUEST',
        '[InvoiceResponse] GetInvoices // SUCCESS',
        '[InvoiceResponse] GetInvoices // FAILURE'
    )<any, InvoiceResponse, {}>(),
    removeInvoice: createAsyncAction(
        '[InvoiceResponse] removeInvoice // REQUEST',
        '[InvoiceResponse] removeInvoice // SUCCESS',
        '[InvoiceResponse] removeInvoice // FAILURE'
    )<string, InvoiceResponse, {}>(),
    previewInvoice: createAsyncAction(
        '[string] previewInvoice // REQUEST',
        '[string] previewInvoice // SUCCESS',
        '[string] previewInvoice // FAILURE'
    )<string, string, any>(),
    ignoreSelected: createAsyncAction(
        '[InvoiceResponse] ignoreSelected // REQUEST',
        '[InvoiceResponse] ignoreSelected // SUCCESS',
        '[InvoiceResponse] ignoreSelected // FAILURE'
    )<{ invoiceGroup: string, invoiceNumbers: string[] }, {}, {}>(),
    holdSelected: createAsyncAction(
        '[InvoiceResponse] holdSelected // REQUEST',
        '[InvoiceResponse] holdSelected // SUCCESS',
        '[InvoiceResponse] holdSelected // FAILURE'
    )<{ invoiceGroup: string, invoiceNumbers: string[] }, {}, {}>(),
    approveSelected: createAsyncAction(
        '[InvoiceResponse] approveSelected // REQUEST',
        '[InvoiceResponse] approveSelected // SUCCESS',
        '[InvoiceResponse] approveSelected // FAILURE'
    )<{ invoiceGroup: string, invoiceNumbers: string[] }, {}, {}>(),
    approveStandardInvoices: createAsyncAction(
        '[InvoiceResponse] approveStandardInvoices // REQUEST',
        '[InvoiceResponse] approveStandardInvoices // SUCCESS',
        '[InvoiceResponse] approveStandardInvoices // FAILURE'
    )<string, {}, {}>(),
    clearPreview: createStandardAction('[preview] CLEAR_PREVIEW')<void>(),
    closePreviewDisabledModal: createStandardAction('[preview] closePreviewDisabledModal')<void>(),
    fetchingNewData: createStandardAction('[data] FETCH_NEW')<void>(),
    completedFetchingNewData: createStandardAction('[data] GOT_NEW')<void>(),
    approveInvoiceWithUpload: createAsyncAction(
        '[InvoiceResponse] approveInvoiceWithUpload // REQUEST',
        '[InvoiceResponse] approveInvoiceWithUpload // SUCCESS',
        '[InvoiceResponse] approveInvoiceWithUpload // FAILURE'
    )<{ invoiceNumber: number, fileData: any }, {}, {}>(),
    getInvoicePdfData: createAsyncAction(
        '[InvoiceResponse] getInvoicePdfData // REQUEST',
        '[InvoiceResponse] getInvoicePdfData // SUCCESS',
        '[InvoiceResponse] getInvoicePdfData // FAILURE'
    )<{ documentKey: string, download: string }, {}, {}>(),
    openInvoiceTab: createAsyncAction(
        '[InvoiceResponse] openInvoiceTab // REQUEST',
        '[InvoiceResponse] openInvoiceTab // SUCCESS',
        '[InvoiceResponse] openInvoiceTab // FAILURE'
    )<{ documentKey: string }, {}, {}>(),
    approveBatch: createAsyncAction(
      '[InvoiceResponse] approveStandardInvoicesBatch // REQUEST',
      '[InvoiceResponse] approveStandardInvoicesBatch // SUCCESS',
      '[InvoiceResponse] approveStandardInvoicesBatch // FAILURE'
  )<{ invoiceGroup: string, invoiceType: string, batchSize: number }, {}, {}>(),
};

export type InvoiceActions = ActionType<typeof actions>;

export default actions;
